import { APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { ITranslationService, I18NEXT_SERVICE } from 'angular-i18next';
import { InitOptions } from 'i18next';
import * as translation from './locales/en/translation.json';
import * as config from './locales/en/config.json';
import * as tickets from './locales/en/tickets.json';

import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import { environment } from '@environment';

function localeIdFactory(i18next: ITranslationService) {
  return i18next.language;
}

const loadPathGenerator = (lngs: string[], namespaces: string[]): string =>
  `${environment.cdnBaseUrl}/dictionary/${namespaces[0]}.json`;

// Ref: https://github.com/i18next/i18next-http-backend#backend-options
export const httpBackEndOptions = {
  loadPath: loadPathGenerator,
  allowMultiLoading: false, // only try to load one culture at a time
  crossDomain: true, // allow cross domain request
  overrideMimeType: false, // We use application/octet-stream
};

const fileSystemBackendOptions = {
  loadPath: 'assets/locales/{{lng}}/{{ns}}.json',
};

export const buildi18nOptions = (): InitOptions => {
  const backends = environment.production ? [HttpBackend] : [];
  const backendOptions = environment.production
    ? [httpBackEndOptions, fileSystemBackendOptions]
    : [];

  const resources = environment.production
    ? undefined
    : { en: { translation, config, tickets } };
  return {
    lng: 'en',
    fallbackLng: 'en',
    load: 'currentOnly',
    ns: ['translation', 'config', 'tickets'],
    defaultNS: 'translation',
    debug: environment.production ? false : true,
    returnEmptyString: true,
    returnNull: false,
    backend: {
      backends,
      backendOptions,
    },
    resources,
    saveMissing: true,
  };
};

function appInit(i18next: ITranslationService) {
  return () => i18next.use(ChainedBackend).init(buildi18nOptions());
}

export const I18N_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: appInit,
    deps: [I18NEXT_SERVICE],
    multi: true,
  },
  {
    provide: LOCALE_ID,
    deps: [I18NEXT_SERVICE],
    useFactory: localeIdFactory,
  },
];
